<script>
import methods from './methods.js'
import Container from '../../components/container/index.vue'
import ButtonGroup from '../../components/buttonGroup'
import Chart from './chart/index.vue'
export default {
  name: "trend",
  components: {Container,ButtonGroup,Chart},
  mixins: [methods]
}
</script>
<template>
 <Container icon="https://s6.bihukankan.com/img/1695710272510.svg" title="店铺动销趋势">
    <template #head>
      <ButtonGroup v-model="filter" :list="buttonList"/>
    </template>
    <Chart :data="chartDataApi" :filter="filter"/>
  </Container>
</template>

